import { render, staticRenderFns } from "./BrandLogoTextboxAcadetmoi.vue?vue&type=template&id=41cd397a&"
import script from "./BrandLogoTextboxAcadetmoi.vue?vue&type=script&lang=js&"
export * from "./BrandLogoTextboxAcadetmoi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports